/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Brand_Logo_Subtitle1Inputs */

const vi_sitesettings_brand_logo_subtitle1 = /** @type {(inputs: Sitesettings_Brand_Logo_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng phụ dưới logo`)
};

/**

* @param {Sitesettings_Brand_Logo_Subtitle1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_brand_logo_subtitle1 = /** @type {((inputs?: Sitesettings_Brand_Logo_Subtitle1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Brand_Logo_Subtitle1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_brand_logo_subtitle1(inputs)
});
export { sitesettings_brand_logo_subtitle1 as "siteSettings_brand_logo_subtitle" }